import React, { useState, useEffect } from "react";
import "./index.scss";
import { Modal, Button, Icon, Toast } from "antd-mobile";
import { useTranslation } from '@/i18n';
import walletImg from "@/assets/images/wallet.png";
import checkboxImg from "@/assets/images/checkbox.png";
import { freeCardBuy } from "@/api";
import { createNonceStr, md5, getLocationSearch } from "@/utils/utils";
import request from "@/utils/request";
import { useLocation } from "react-router-dom";

const FreeCommissionCardDetail = () => {
  const t = useTranslation();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  let token = getLocationSearch().token;
  let appKey = "app_h5";
  let secret = "11dc72cf-88b0-46cd-91d7-b1a77fd69ee1";
  let timestamp = new Date().getTime();
  let random = createNonceStr();
  let tempStr = `appKey${appKey}secret${secret}timestamp${timestamp}random${random}token${token}`;
  let sign = md5(tempStr, 32).toString(16).toLocaleUpperCase();
  const params = {
    appKey: appKey,
    timestamp: timestamp,
    random: random,
    token: token,
    sign: sign,
  };
  const [cardData, setCardData] = useState(
    JSON.parse(queryParams.get("cardData")) || {}
  );
  const [walletInfo, setWalletInfo] = useState(
    JSON.parse(queryParams.get("walletInfo")) || {}
  );
  const [isBalanceSufficient, setIsBalanceSufficient] = useState(
    walletInfo.balance >= +(+cardData.sellPrice * 100).toFixed(0)
  );
  const [visible, setVisible] = useState(false);
  const [countdown, setCountdown] = useState({
    days: 0,
    hours: "00",
    minutes: "00",
    seconds: "00",
  });

  const calculateCountdown = (expiryDate) => {
    const now = new Date().getTime();
    const distance = expiryDate - now;

    if (distance < 0) {
      return {
        days: 0,
        hours: "00",
        minutes: "00",
        seconds: "00",
      };
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = String(
      Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    ).padStart(2, "0");
    const minutes = String(
      Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
    ).padStart(2, "0");
    const seconds = String(
      Math.floor((distance % (1000 * 60)) / 1000)
    ).padStart(2, "0");

    return {
      days,
      hours,
      minutes,
      seconds,
    };
  };

  const pay = async () => {
    Toast.loading(t('freeCard.buyModal.paying'), 0, () => {}, true);
    const res = await request.post(
      `${freeCardBuy}${cardData.freeCardId}`,
      { token },
      params
    );
    Toast.hide();
    if (res.data.errorCode == 0) {
      Toast.success(t('freeCard.buyModal.paySuccess'));
      setVisible(false);
      window.history.back();
    } else if (res.data.errorMsg) {
      Toast.fail(res.data.errorMsg, 2);
    }
  };
  const openPay = (e) => {
    e.stopPropagation();
    setIsBalanceSufficient(
      walletInfo.balance >= +(+cardData.sellPrice * 100).toFixed(0)
    );
    setVisible(true);
  };

  useEffect(() => {
    document.title = t('freeCard.detailTitle');
    if (!cardData.sellEndTime) {
      return;
    }
    const expiryDate = new Date(cardData.sellEndTime).getTime();
    if (isNaN(expiryDate)) {
      return;
    }
    const interval = setInterval(() => {
      setCountdown(calculateCountdown(expiryDate));
    }, 1000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div  className={`free-commission-card-detail ${cardData.status !== 1 ||cardData.buy ? "card_gray_filter" : ""}`}>
      <Modal
        visible={visible}
        popup
        closable
        transparent
        onClose={() => setVisible(false)}
        animationType="slide-up"
        title={t('freeCard.buyModal.title')}
      >
        <div className="modal_content">
          <div className="price">
            {cardData.sellPrice}
            <div className="unit">{t('freeCard.card.yuan')}</div>
          </div>
          <div className="wallet_info">
            <div className="left">
              <img src={walletImg}></img>{t('freeCard.buyModal.walletPay')}
              <div className="wallet_info_tips">
                {t('freeCard.buyModal.walletBalance', { balance: (walletInfo.balance / 100).toFixed(2) })}
              </div>
            </div>
            <div className="right">
              <img src={checkboxImg}></img>
            </div>
          </div>
          <div
            className="wallet_info_error_tips"
            style={{ display: isBalanceSufficient ? "none" : "block" }}
          >
            {t('freeCard.buyModal.insufficientBalance')}
          </div>
          <div className="btn_box">
            <Button
              className="btn"
              type="warning"
              onClick={pay}
              disabled={!isBalanceSufficient}
            >
              {t('freeCard.buyModal.buyNow')}
            </Button>
          </div>
        </div>
      </Modal>

      <div
        className={`card`}
        key={cardData.freeCardId}
      >
        <div className="tips">
          <div className="name">{t('freeCard.card.name', { name: cardData.cardName })}</div>
          <div className="date">{t('freeCard.card.cardId', { id: cardData.freeCardId })}</div>
        </div>
        <div className="card_type">
          <div className="label">{t('freeCard.card.freeDate')}</div>
          <div className="value">
            {cardData.freeEndDate ? `${cardData.freeDate} ~ ${cardData.freeEndDate}` : cardData.freeDate}
          </div>
          <div className="city">{cardData.cityName}</div>
        </div>
        <div className="content">
          <div className="price">{t('freeCard.card.freeTimeSlot', { slot: cardData.freeTimeSlot })}</div>
          <div className="progress-tips">
            {t('freeCard.card.remaining', { remaining: cardData.remainderQuantity, total: cardData.sellQuantity })}
          </div>
        </div>
      </div>
      <div className="banner_tips">
        <div className="price">
          <div className="unit">￥</div>
          <div> {cardData.sellPrice}</div>
        </div>
        {cardData.buy ? (
          <div className="status_tag">{t('freeCard.status.purchased')}</div>
        ) :cardData.status === 0 ? (
          <div className="status_tag">{t('freeCard.status.pending')}</div>
        ) : cardData.status === 2 ? (
          <div className="status_tag">{t('freeCard.status.ended')}</div>
        ) : cardData.status === 3 ? (
          <div className="status_tag">{t('freeCard.status.cancelled')}</div>
        ) : 
        <div className="time">
        <div>{t('freeCard.detail.purchaseTimeLeft')}</div>
        <div className="time_f">
          <div className="num_box">{countdown.days}</div>{t('freeCard.detail.days')}
          <div className="num_box">{countdown.hours}</div>:
          <div className="num_box">{countdown.minutes}</div>:
          <div className="num_box">{countdown.seconds}</div>
        </div>
      </div>}
       
      </div>
      <div className="info_card">
        <div className="title">{t('freeCard.detail.usageInstructions')}</div>
        <div className="card_item">{cardData.cardDesc}</div>
      </div>
      <div className="bottom">
        {cardData.buy ? null: (
          <Button
            className="btn"
            type="warning"
            onClick={openPay}
            disabled={cardData.remainderQuantity === 0}
          >
            {t('freeCard.buyModal.buyNow')}
          </Button>
        )}
      </div>
    </div>
  );
};
export default FreeCommissionCardDetail;
